module.exports = __webpack_public_path__ + "static/media/dark_pattern_bg.3ead98d0.png";